import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { NgIf } from '@angular/common';

@Component({
	selector: 'recipe-contributor',
	template: `
		<section class="contributor" *ngIf="name">
			<address i18n="@@recipeContributor">
				This recipe was sent in by
				<ng-container *ngIf="link; else asText">
					<a [href]="link" rel="author" target="_blank" class="contributor-name">{{ name }}</a>
				</ng-container>
				<ng-container *ngIf="name && town"> of {{ town }}</ng-container
				>.
			</address>
		</section>
		<ng-template #asText>
			<span class="author contributor-name">{{ name }}</span>
		</ng-template>
	`,
	styleUrls: ['./contributor.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: true,
	imports: [NgIf]
})
export class ContributorComponent {
	@Input() name: string;
	@Input() town: string;
	@Input() link: string;
}
